import { FullPageSliderComponent } from '@monorepo/frontend-libs-cms-shortcodes-full-page-slider';
import { AutoWidthSliderComponent } from '@monorepo/frontend-libs-cms-shortcodes-auto-width-slider';

jQuery(() => {
	FullPageSliderComponent.compileAll();
	AutoWidthSliderComponent.compileAll();
});
